export default __webpack_public_path__ + "static/media/A5_14.b7fc5d83.mp3";